/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react'

import { ErrorProps } from './common'
import { eventWaiverBySlug } from '../api/queries'
import { Event } from '../models/API'
import { fetchQuery } from '../utils/ApiUtils'
import { jsonParse } from '../utils/ObjectUtil'

interface Props {
  slug: string | null | undefined
}

const useEventWaiver = ({ slug }: Props) => {
  const [event, setEvent] = useState<Event | null>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<ErrorProps>()

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      if (didCancel) return
      setLoading(true)

      try {
        const { items } = (await fetchQuery('eventBySlug', eventWaiverBySlug, {
          slug,
        })) as unknown as { items: Event[] }

        if (items.length > 0)
          setEvent({
            ...items[0],
            waiver: jsonParse(jsonParse(items[0].waiver as string)),
          })
      } catch (e) {
        console.log(e)
        setError({
          title: 'Fail to load event',
          message: '',
        })
      }
      setLoading(false)
    }

    if (slug) fetchData()

    return () => {
      didCancel = true
    }
  }, [slug])

  return {
    event,
    apiLoading: loading,
    apiError: error,
  }
}

export default useEventWaiver
